// extracted by mini-css-extract-plugin
module.exports = {"icon-box":"icon-box__3YRj6","active":"active__MckTL"};